/* eslint-disable */
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function servicesSelector(servicesSelectorEl) {
  const serviceItems = servicesSelectorEl.querySelectorAll('.services-selector .service-items .service-item');
  const itemHeadings = servicesSelectorEl.querySelectorAll('.services-selector .service-item .service-item-heading');
  const images = servicesSelectorEl.querySelectorAll('.services-selector .images img');
  const serviceItemsWrapper = servicesSelectorEl.querySelectorAll('.services-selector .service-items');
  const itemContents = servicesSelectorEl.querySelectorAll(
    '.services-selector .service-item .service-item-content-inner',
  );

  let activeIndex = 0;
  let prevIndex;

  var slider = servicesSelectorEl.querySelector('#service-selector-range');

  // Update the current slider value (each time you drag the slider handle)
  slider.oninput = function () {
    prevIndex = activeIndex;
    activeIndex = this.value;
    setActiveItem();
  };

  slider.addEventListener('input', () => {});

  document.addEventListener(
    'touchmove',
    (event) => {
      return false;
    },
    { passive: false },
  );

  updateItemOpacity();

  itemHeadings.forEach((item, index) => {
    item.addEventListener('click', (e) => {
      prevIndex = activeIndex;
      activeIndex = index;
      setActiveItem();
      slider.value = activeIndex;
    });
  });

  function updateItemOpacity() {
    serviceItems[activeIndex].style.opacity = 1;

    for (let i = activeIndex - 1; i >= 0; i--) {
      if (serviceItems[i]) {
        serviceItems[i].style.opacity = Math.max(0, (1 / Math.abs(activeIndex - i)) * 0.8);
      }
    }

    for (let j = activeIndex + 1; j < serviceItems.length; j++) {
      if (serviceItems[j]) {
        serviceItems[j].style.opacity = Math.max(0, (1 / Math.abs(activeIndex - j)) * 0.8);
      }
    }
  }

  function setActiveItem() {
    serviceItems[prevIndex].classList.remove('is-active');
    serviceItems[activeIndex].classList.add('is-active');

    gsap.to(itemContents[prevIndex], {
      height: 0,
      duration: 0.3,
    });

    gsap.fromTo(
      itemContents[activeIndex],
      {
        height: 0,
        opacity: 0,
      },
      {
        height: 'auto',
        opacity: 1,
        duration: 1,
      },
    );

    let offsetY = 0;

    for (let k = 0; k < activeIndex; k++) {
      offsetY += itemHeadings[k].getBoundingClientRect().height;
    }

    gsap.to(serviceItemsWrapper, {
      y: -offsetY - 4,
      duration: 0.3,
    });

    if (images.length == serviceItems.length) {
      images[prevIndex]?.classList.remove('active');
      images[activeIndex]?.classList.add('active');
    }

    updateItemOpacity();
  }
}

function getAbsolutePosition(parentElement, childElement) {
  updatePos();

  window.addEventListener('resize', () => {
    updatePos();
  });

  function updatePos() {
    const parentRect = parentElement.getBoundingClientRect();
    const childRect = childElement.getBoundingClientRect();

    const position = {
      top: childRect.top - parentRect.top,
      left: childRect.left - parentRect.left,
    };

    parentElement.style.setProperty('--nav-top', `${position.top}px`);
  }
}
window.addEventListener('load', () => {
  const servicesSelectorEl = document.querySelector('.paragraph--type--services-selector .services-selector');

  if (servicesSelectorEl) {
    servicesSelector(servicesSelectorEl);
  }
});
